"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HarvestUserHandle = void 0;
class HarvestUserHandle {
    constructor(user) {
        this.id = user.id;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.email = user.email;
        this.roles = user.roles;
        this.is_active = user.is_active;
    }
    getTeam() {
        return this.roles
            .map((role) => (role.startsWith("ee-") ? role.substr(3) : role))
            .map((role) => role.toLowerCase().replace(/-/g, " "))
            .find((role) => role.startsWith("pod") || role.startsWith("squad"));
    }
    getName() {
        return this.firstName || "" + this.lastName || "";
    }
    compareName(other) {
        return this.getName().localeCompare(other?.getName() || "");
    }
}
exports.HarvestUserHandle = HarvestUserHandle;
//# sourceMappingURL=HarvestUserHandle.js.map